webpackJsonp([114276838955818,60335399758886],{

/***/ 166:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(344);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(166);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(147);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_Component) {
	  _inherits(Footer, _Component);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Footer.prototype.render = function render() {
	    return _react2.default.createElement(
	      "footer",
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-sm-6" },
	            _react2.default.createElement(
	              "div",
	              { className: "weight" },
	              _react2.default.createElement(
	                "h4",
	                { className: "footer-logo" },
	                _react2.default.createElement("img", { src: "/images/logo_white.svg", alt: "flogo", style: { width: '170px' } })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-sm-6" },
	            _react2.default.createElement(
	              "div",
	              { className: "weight" },
	              _react2.default.createElement(
	                "h4",
	                null,
	                this.props.lang == 'en' ? 'Contact' : 'Contatti'
	              ),
	              _react2.default.createElement(
	                "ul",
	                null,
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement("i", { className: "fa fa-phone", "aria-hidden": "true" }),
	                  " Marco Scatto +39 335 1830434"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement("i", { className: "fa fa-phone", "aria-hidden": "true" }),
	                  " Enrico Vittadello +39 348 3341964"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement("i", { className: "fa fa-envelope-o", "aria-hidden": "true" }),
	                  " info@vedutaconsult.it"
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Footer;
	}(_react.Component);
	
	exports.default = Footer;
	module.exports = exports["default"];

/***/ }),

/***/ 343:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(147);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LanguageSelection = function (_Component) {
	  _inherits(LanguageSelection, _Component);
	
	  function LanguageSelection() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, LanguageSelection);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      currentLang: 'it'
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  LanguageSelection.prototype.itClick = function itClick() {
	    if (this.state.currentLang !== 'it') {
	      window.location.replace(window.location.href.replace('/en', '/it'));
	      this.setState({ currentLang: 'it' });
	    }
	  };
	
	  LanguageSelection.prototype.enClick = function enClick() {
	    if (this.state.currentLang !== 'en') {
	      window.location.replace(window.location.href.replace('/it', '/en'));
	      this.setState({ currentLang: 'en' });
	    }
	  };
	
	  LanguageSelection.prototype.componentDidMount = function componentDidMount() {
	    this.setState({ currentLang: this.props.lang || 'it' });
	  };
	
	  LanguageSelection.prototype.render = function render() {
	    var currentLang = this.state.currentLang;
	
	    return _react2.default.createElement(
	      "div",
	      { className: "navbar-language" },
	      _react2.default.createElement("img", { src: "/it.svg", className: currentLang != 'it' ? 'selectable' : '', style: { width: '27px' }, onClick: this.itClick.bind(this) }),
	      _react2.default.createElement("img", { src: "/en.svg", className: currentLang != 'en' ? 'selectable' : '', style: { width: '30px', marginLeft: '10px' }, onClick: this.enClick.bind(this) })
	    );
	  };
	
	  return LanguageSelection;
	}(_react.Component);
	
	exports.default = LanguageSelection;
	module.exports = exports["default"];

/***/ }),

/***/ 344:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LanguageSelection = __webpack_require__(343);
	
	var _LanguageSelection2 = _interopRequireDefault(_LanguageSelection);
	
	var _Footer = __webpack_require__(342);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Layout = function (_Component) {
	  _inherits(Layout, _Component);
	
	  function Layout() {
	    _classCallCheck(this, Layout);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Layout.prototype.isHomePage = function isHomePage() {
	    return this.props.location.pathname.match(/\/en(\/)?$/) || this.props.location.pathname.match(/\/it(\/)?$/);
	  };
	
	  Layout.prototype.render = function render() {
	    var lang = this.props.location.pathname.substring(1, 3);
	    return _react2.default.createElement(
	      'div',
	      { style: { height: '100%' } },
	      _react2.default.createElement(
	        'header',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'top-nav' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-6 col-lg-6 ' },
	                _react2.default.createElement(
	                  'ul',
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement('i', { className: 'fa fa-envelope-o', 'aria-hidden': 'true' }),
	                    ' info@vedutaconsult.it'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-6 col-lg-6 text-right' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'top-social' },
	                  _react2.default.createElement(
	                    'ul',
	                    null,
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      'LinkedIn:'
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'a',
	                        { href: 'https://www.linkedin.com/in/marco-scatto-6b54977/', title: 'Marco Scatto' },
	                        'Marco Scatto'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'a',
	                        { href: 'https://www.linkedin.com/in/enrico-vittadello-358b7b39/', title: 'Enrico Vittadello' },
	                        'Enrico Vittadello'
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'mainNav', className: 'navbar navbar-fixed-top ' + (!this.isHomePage() ? '' : '') + ' affix-top' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'nav',
	                { className: 'navbar navbar-inverse navbar-default' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'navbar-header' },
	                  _react2.default.createElement(
	                    'button',
	                    { type: 'button', className: 'navbar-toggle collapsed', 'data-toggle': 'collapse', 'data-target': '#bs-example-navbar-collapse-1' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'sr-only' },
	                      'Toggle navigation'
	                    ),
	                    _react2.default.createElement('span', { className: 'icon-bar' }),
	                    _react2.default.createElement('span', { className: 'icon-bar' }),
	                    _react2.default.createElement('span', { className: 'icon-bar' })
	                  ),
	                  this.isHomePage() ? _react2.default.createElement(
	                    'a',
	                    { className: 'navbar-brand', href: '#' },
	                    _react2.default.createElement('img', { src: '/images/logo.svg', alt: 'logo', style: { width: '140px' } })
	                  ) : _react2.default.createElement(
	                    'a',
	                    { className: 'navbar-brand', href: '#' },
	                    _react2.default.createElement('img', { src: '/images/logo.svg', alt: 'logo', style: { width: '140px' } })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'collapse navbar-collapse navbar-right', id: 'bs-example-navbar-collapse-1', 'data-hover': 'dropdown', 'data-animations': 'fadeIn fadeInLeft fadeInUp fadeInRight' },
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'nav navbar-nav' },
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'a',
	                        { href: '/' + lang },
	                        'Home'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'a',
	                        { href: '/' + lang + '/about' },
	                        lang == 'en' ? 'About us' : 'Chi siamo'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'a',
	                        { href: '#', 'data-toggle': 'dropdown', 'aria-expanded': 'true' },
	                        'Aree d\'intervento ',
	                        _react2.default.createElement('i', { className: 'fa fa-angle-down', 'aria-hidden': 'true' })
	                      ),
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'dropdown-menu arrow' },
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            { href: '/' + lang + '/management' },
	                            'Strategic Management'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            { href: '/' + lang + '/administration' },
	                            'Amministrazione e bilancio'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            { href: '/' + lang + '/finance' },
	                            'Finanza e tesoreria'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            { href: '/' + lang + '/supplychain' },
	                            'Supply Chain e Logistica'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            { href: '/' + lang + '/network' },
	                            'Sviluppo canali'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            { href: '/' + lang + '/organization' },
	                            'Organizzazione e processi'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'a',
	                        { href: '/' + lang + '/contact' },
	                        lang == 'en' ? 'Contact' : 'Contatti'
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      ),
	      this.props.children(),
	      _react2.default.createElement(_Footer2.default, { lang: lang })
	    );
	  };
	
	  return Layout;
	}(_react.Component);
	
	exports.default = Layout;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-2ad9f120fb50d17d4e94.js